import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Download from './pages/Download';
import DownloadEnhanced from './pages/DownloadEnhanced';
import APKsListing from './pages/APKsListing';
import AdminPanel from './pages/AdminPanel';
import ShareRedirect from './pages/ShareRedirect';
import Login from './pages/Login';

function Layout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return (
      <div className="min-h-screen bg-[#0a0a0a]">
        <Routes>
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/apk/:token" element={<DownloadEnhanced />} />
          <Route path="/download" element={<APKsListing />} />
          <Route path="/download-simple" element={<Download />} />
          <Route path="/s/:token" element={<DownloadEnhanced />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
